import { Outlet, useLocation } from "react-router-dom";

import Header from "./header/Header";
import Footer from "./footer/Footer";
import QuickRight from "./quick/QuickRight";
import AMHeader from "./header/AMHeader";
import AHeader from "./header/AHeader";

const Layout = () => {
  const { pathname } = useLocation();

  console.log(pathname);

  if (pathname.includes("login")) {
    return (
      <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
        <Outlet />
      </div>
    );
  }
  if (pathname.includes("admin")) {
    if (!sessionStorage.getItem("email")) {
      window.location.href = "/admin/login";
      return <></>;
    }
    return (
      <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
        <AMHeader />
        <AHeader />
        <div className="relative w-full h-full max-w-screen-2xl py-32 lg:py-36 px-2 lg:pl-[280px] 2xl:pl-[300px]">
          <Outlet />
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full max-w-[100vw] overflow-x-hidden">
      <Header />
      <div className=" relative w-full h-full mt-20 xl:mt-24">
        <Outlet />
      </div>
      <QuickRight />
      <Footer />
    </div>
  );
};

export default Layout;
